import React, { createContext, useContext, useEffect } from 'react';
import { useHttpRequest } from './HttpRequest';
import { HTTP_METHODS } from 'src/config/constants';

const CompanyContext = createContext();

const CompanyProvider = ({ children }) => {

    const { isLoading, error, sendRequest } = useHttpRequest();
    const token = localStorage.getItem("token");

    const getCompanyList = async (requestBody) => {
        const headers = {
            "Content-Type": "application/json",
        }
        const responseData = await sendRequest(
            `/company/list`,
            HTTP_METHODS.GET,
            headers,
        )
        return responseData
    }
    const createNewCompany = async (requestBody) => {
        const headers = {
            // "Accept":"application/json",
            // "Content-Type": "application/json"
        }
        const responseData = await sendRequest(
            `/company`,
            HTTP_METHODS.POST,
            headers,
            requestBody
        )
        return responseData
    }

    const getCompany = async (companyId) => {
        const headers = { "Content-Type": "application/json" };

        const responseData = await sendRequest(
            `/company/${companyId}`,
            HTTP_METHODS.GET,
            headers,
        );
        return responseData;
    };

    const inactiveCompany = async (comoanyId) => {
        console.log("On inactiveCompany");
        const headers = {};

        const responseData = await sendRequest(
            `/company/${comoanyId}/inactive`,
            HTTP_METHODS.PUT,
            headers
        );
        console.log(responseData);
        return responseData;
    };

    const activeCompany = async (comoanyId) => {
        console.log("On activeCompany");
        const headers = {};

        const responseData = await sendRequest(
            `/company/${comoanyId}/active`,
            HTTP_METHODS.PUT,
            headers
        );
        console.log(responseData);
        return responseData;
    };

    return (
        <CompanyContext.Provider value={{
            isLoading,
            error,
            createNewCompany,
            getCompany,
            getCompanyList,
            inactiveCompany,
            activeCompany
        }}>
            {children}
        </CompanyContext.Provider>
    );
}

const useCompany = () => {
    const companyContext = useContext(CompanyContext)
    return companyContext
}

export { CompanyProvider, useCompany }